import { combineReducers } from "redux";
import { basicReducer, BasicState } from "../basic/reducers/basicReducer";

export interface AppState {
    basic: BasicState;
}

export const appRootReducer = combineReducers({
    basic: basicReducer,
});